import "./index.scss"

require.context("./static", false, /\.(svg)$/)
